<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.EDIT') }} {{ $t('CONTRACTS.ITEM') }}
      <v-spacer />
      <v-chip
        v-if="form.status"
        dark
        small
        :color="form.status.color"
        class="mx-1"
      >
        {{ form.status.name }}
      </v-chip>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="6">
            <strong class="mr-1">{{ $t('ITEM.DATE_ENTERED') }}:</strong>
            <span>{{ form.created_at | dateFormat }}</span>
          </v-col>
          <v-col class="text-right" cols="6">
            <strong class="mr-1">{{ $t('ITEM.UPDATED_AT') }}:</strong>
            <span>{{ form.updated_at | dateFormat }}</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <building-details :details="details" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="form.name"
              name="name"
              :label="$t('CONTRACTS.NAME')"
              :readonly="readonly"
              counter="255"
              :error-messages="errors.name"
              :rules="getRulesByName('textLine')"
              @input="updateValue('name', $event)"
            />
          </v-col>
          <v-col cols="12">
            <contract-form
              v-model="form"
              :errors="errors"
              :action="$options.action"
              :building-complex-id="buildingComplexId"
              @input="emitter"
              @update-prop="updateProp(...arguments)"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <confirm-dialog ref="confirm" />
      <v-spacer />
      <v-btn
        depressed
        color="primary"
        :disabled="!valid"
        @click="updateRelatedCompany"
      >
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formEditable, { EDIT } from '@/modules/_global/mixins/form-editable';
import ContractForm from '@/modules/building_complexes_contracts/components/forms/ContractForm';
import BuildingDetails from '@/modules/building_complexes_contracts/components/forms/BuildingDetails';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'ShowContract',

  components: {
    BuildingDetails,
    ContractForm,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  filters: {
    dateFormat
  },

  action: EDIT,

  mixins: [formEditable],

  props: {
    buildingComplexId: {
      type: Number,
      required: true
    },
    details: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: false,
      form: {}
    };
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    updateRelatedCompany() {
      this.$emit('update', { ...this.form });
    },

    remove() {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            this.$emit('remove');
          }
        });
    }
  }
};
</script>
